import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { notification } from "antd";
import { openNotificationWithIcon } from "../../libs/utils";

/** ACTIONs */
import { getTreeCategoryNew } from "../../store/actions/documents/category";
import { getDetailDocument } from "../../store/actions/detailsDocument/index";
import { resetClassification } from "../../store/actions/documents/classification";

/** COMPONENTS */
import Classificator from "../../components/classificator/index";
import Page from "../../components/general/page";
import { FormattedMessage } from "react-intl";
import { useIntl } from "react-intl";

const ClassificatorPage = ({ pageRef}) => {

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const auth = useSelector(state => state.auth);
  const categoryDocuments = useSelector(state => state.categoryDocuments);
  const company = useSelector(state => state.company);
  const classification = useSelector(state => state.documents.classification);
  const detailsDocument = useSelector(state => state.detailsDocument);
  const main = useSelector(state => state.main);
  const accountantSelected = main.accountantSelected;
  const companySelected = main.companySelected;
  const accountantIdSelected = main.accountantIdSelected;
  const clientIdSelected = main.clientIdSelected;
  const myType = main.myType;

  const intl = useIntl();

  useEffect(() => {
    if (categoryDocuments.length === 0) {
      dispatch(getTreeCategoryNew());
    }
    if (myType !== "STUDIO") {
      navigate("/documenti");
    }

    /** ho bisogno dei tag preinseriti per poter popolare eventualmente in edit la form */
    if (!detailsDocument.info.details) {
      let docIdByUrl = location.pathname.split("cambio-classificazione/")[1];
      if (auth && docIdByUrl) {
        dispatch(getDetailDocument(docIdByUrl));
      }
    }

    if (classification && classification.statusClassification.status.ended) {
      openNotificationWithIcon(
        notification,
        "success",
        <FormattedMessage id="documents.classificator.feeback.okTitle" />,
        <FormattedMessage id="documents.classificator.feeback.okMessage" />,
        null,
        null
      );

      dispatch(resetClassification());
      navigate("/documenti");
    }
  }, [
    auth,
    categoryDocuments,
    myType,
    detailsDocument.info.details,
    classification && classification.statusClassification
  ]);
  const ragioneSociale = company?.companies?.find(el => {
    return el.codiceFiscale === companySelected;
  }).ragioneSociale;

  return (
    <Page
      pageRef={pageRef}
      className="contentStructure"
      style={{ display: "flex", flexDirection: "column" }}
      title={<FormattedMessage id="documents.classificator.title" />}
      subtitle={ragioneSociale + " / " + intl.formatMessage({ id: "generic.fiscalCodeAbbreviation" }) + " " + companySelected}      
      backUrl={
        window.location.href.indexOf("ask-answer=") > -1
          ? "/ask-answer/" + window.location.href.split("ask-answer=")[1]
          : "/documenti"
      }
      backText={
        window.location.href.indexOf("ask-answer=") > -1
          ? <FormattedMessage id="documents.classificator.backAsk" />
          : <FormattedMessage id="documents.classificator.back" />
      }
    >
      <Classificator
        accountantSelected={accountantSelected}
        accountantIdSelected={accountantIdSelected}
        companySelected={companySelected}
        clientIdSelected={clientIdSelected}
        documentId={
          location.pathname.split("cambio-classificazione/")[1]
        }
        myType={myType}
      />
    </Page>
  );
};

export default ClassificatorPage;
